import { useIsOptoutAllMessages } from '@atlassian/optout-all-messages';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useLicensedProducts } from '@atlassian/jira-tenant-context-controller/src/components/licensed-products/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const useIsProjectPagesOptedIn = () => {
	const cloudId = useCloudId();
	const atlassianAccountId = useAccountId();
	const licensedProducts = useLicensedProducts();
	const hasConfluence = licensedProducts.confluence;
	const { optoutStatus } = useIsOptoutAllMessages(
		'jira-project-pages',
		cloudId,
		atlassianAccountId,
		{ isDisabled: !fg('optout_all_messages_project_pages') },
	);
	const isOptedIn =
		hasConfluence || !fg('optout_all_messages_project_pages') || optoutStatus === 'no-opt-out';

	return { isOptedIn };
};
